<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<swimlane
	*ngFor="let swim of swimlane$ | async"
	[swimlane$]="swim.ob$"
	(onClose)="close($event)"
	(onDelete)="delete($event)"
	(onUpdate)="update($event)"
	[includeTickets]="includeTickets"
	(includeTicketsChange)="includeTicketsUpdated($event)"
></swimlane>
